<template>
	<div class="dark-bank">
		<!-- 装饰性背景 -->
		<div class="bg-gradient"></div>

		<div class="container">

			<!-- 头部全网数据 -->
			<div class="stats-grid">
				<div class="stat-card">
					<div class="stat-label">ATM 余额</div>
					<div class="stat-value">{{ (balanceOfATM) }}</div>
				</div>
				<div class="stat-card">
					<div class="stat-label">ATM价格</div>
					<div class="stat-value">${{ Number(systemData.priceAtm)/10000 }}</div>
				</div>
				<div class="stat-card">
					<div class="stat-label">BTL价格</div>
					<div class="stat-value">${{ Number(systemData.price)/10000 }}</div>
				</div>
			</div>
			<!-- 闪兑BTL -->
			<div class="add-deposit">
				<div class="add-title">闪兑BTL</div>
				<div class="add-controls">
					<input type="number" v-model="InputAtmCount" @change="onInputAtmChange" placeholder="金额 (ATM)"
						class="amount-input">
					<span class="hint">{{BtlCount}}</span>
					
					<button @click="AtmToBTL" class="submit-btn">兑换BTL</button>
					<span class="hint">兑换后自动开始存款生息</span>
				</div>
			</div>
			<!-- 利率卡片 -->
			<div class="rates-bar">
				<div class="rate-item"><span>1月期</span><strong>月化{{ Number(systemData.rate_month_1)/100 }}%</strong></div>
				<div class="rate-item"><span>3月期</span><strong>月化{{ Number(systemData.rate_month_3)/300 }}%</strong></div>
				<div class="rate-item"><span>6月期</span><strong>月化{{ Number(systemData.rate_month_6)/600 }}%</strong></div>
				<div class="rate-item"><span>1年期</span><strong>月化{{ Number(systemData.rate_month_12)/1200 }}%</strong>
				</div>
			</div>

			<!-- 用户信息卡片 
			<div class="user-card">-->

			<div class="user-stats">
				<div class="user-stat"><span>团队人数</span><strong>{{ userData.teamCount }}</strong></div>
				<div class="user-stat"><span>存款笔数</span><strong>{{ userData.deopsitCount }}</strong></div>
				<div class="user-stat"><span>直推业绩</span><strong>${{ Number(userData.performance)/100 }}</strong></div>
				<div class="user-stat"><span>团队奖励</span><strong>${{ (userData.teamProfit) }}</strong></div>
			</div>
			<div class="user-balance">
				<span>总存入资产</span>
				<strong>${{ Number(userData.deopsit)/100 }} </strong>
			</div>
		</div>

		<!-- 新增存款 -->
		<div style="border: 1px solid #333;border-radius: 6px;margin-top: 12px;">
			<div class="add-deposit">
				<div class="add-title">➕ 新增存款</div>
				<div class="user-header" style="display: none;">
					<div class="user-id" @click="copyAddress('')">
						推荐码:
						<b style="color: aqua;">{{ Number(userData.id).toString(16) }} </b>
						(点击可以复制)
					</div>
					<div class="referrer">推荐人: <b style="color: aqua;">{{ Number(userData.father).toString(16) }} </b>
					</div>
					<!--<div class="address">{{ (userData.addr) }}</div>-->
				</div>
				<div class="user-balance">
					<span>链上总资产</span>
					<strong>{{ balanceOfBTL }} </strong>
				</div>

				<div class="add-controls" style="margin-top: 20px;">
					<input style="display: none;" type="text" v-model="DepositRef" placeholder="推荐人的推荐码，注意不是节点推荐码" class="amount-input">
					<input type="number" v-model="newDepositAmount" placeholder="金额 (USDT)" class="amount-input">
					<div class="type-selector">
						<button v-for="t in depositTypes" :key="t.months"
							:class="['type-btn', { active: newDepositType === t.months }]"
							@click="newDepositType = t.months">
							{{ t.months }}月 <br> 月化{{ Number(t.rateKey)/Number(t.months) }}%
						</button>
					</div>
					<button @click="addDeposit" class="submit-btn">存入资金</button>
				</div>
			</div>
		</div>

		<!-- 存款列表 -->
		<div class="deposit-list">
			<div class="list-header">
				<span>我的存款列表</span>
				<!--<span class="hint">点击取息 · 长按取本金</span>-->
			</div>
			<!--/*uint32 id;
				uint32 createTime;//创建时间
				uint32 takeTime;//取款时间
				uint32 deopsit;//
				uint8 Type;//类型，1代表1个月期，3代表3月期，6代表6月期，12代表12月期
				uint8 status;//状态，0表示正常，1表示本金已取*/ -->
			<div v-for="deposit in deposits" :key="deposit.Index" class="deposit-item"
				:class="{ inactive: deposit.status == 1 }">
				<div class="deposit-info" >
					<div class="deposit-amount">${{ Number(deposit.deopsit)/100 }} USDT</div>
					<div class="deposit-meta">
						<span class="badge">{{ deposit.Type }}月期</span>
						<span class="badge rate-badge">月化收益：{{ getRate(deposit.Type) }}%</span>
						<div class="date">存入时间: {{ formatTime(deposit.createTime) }}</div><br>
						<span class="date">取矿时间: {{ formatTime(deposit.takeTime) }}</span>
					</div> 
					<div class="profit-info">
						<span>已产生利息: ${{ deposit.interest }}</span>
						<!--<span v-if="deposit.takeTime > 0" class="mature">已到期可提取</span>
						<span v-else class="mature-date">到期: {{ formatTime(deposit.takeTime) }}</span>-->
					</div>
					<div class="deposit-actions" >
						<button @click="takeInterest(deposit)" class="action-btn interest" v-if="deposit.isShow >=30">💰 取息</button>
						<button @click="takePrincipal(deposit)" class="action-btn principal" longpress>🏦 取本金</button>
					</div>
				</div>
				
			</div>

			<div v-if="deposits.length === 0" class="empty-state">
				✨ 暂无存款，请存入一笔开始生息 ✨
			</div>
		</div>
	</div>
	</div>
</template>
<script>
	export default {
		name: 'DEOPSIT',

		data() {
			return {
				systemData: {
					userCount: 0, //全网总人数
					price: 0, //1个btl等于多少usdt，这里乘以10000，表示最多取4位小数
					priceAtm: 0, //atm的价格，1个btl等于多少usdt，这里乘以10000，表示最多取4位小数
					rate_month_1: 0, //存款1个月的利率
					rate_month_3: 0, //存3个月的利率
					rate_month_6: 0, //存6个月的利率
					rate_month_12: 0, //存1年的利率
					totalDeopsit: 0, //全网所有存款金额
				},
				userData: {
					id: 0,
					father: 0, //上级
					child: 0, //下级
					brother: 0, //同级
					teamCount: 0, //团队人数
					deopsitCount: 0, //存款笔数
					performance: 0, //直推业绩
					teamProfit: 0, //获得的团队奖励
					deopsit: 0, //存入多少等价USDT
					
					addr: 0,

				},
				userId: 0,
				balanceOfATM: 0,
				BtlCount: "",
				balanceOfBTL: 0,
				depositTypes: [{
					months: 1,
					rateKey: 'rate_month_1'
				}, {
					months: 3,
					rateKey: 'rate_month_3'
				}, {
					months: 6,
					rateKey: 'rate_month_6'
				}, {
					months: 12,
					rateKey: 'rate_month_12'
				}],
				deposits: [],
				newDepositType: "",
				newDepositAmount: "", //存款输入框
				DepositRef: "1c4d91", //推荐人
				InputAtmCount: "", //闪兑输入框
			}
		},
		mounted() {

			this.showUI();
		},
		methods: {

			copyAddress(text) {
				if(text == "")text = Number(this.userData.id).toString(16)
				copyRefURL(text);

			},
			onInputAtmChange() {
				
				this.BtlCount = Math.round(this.InputAtmCount * this.systemData.priceAtm / this.systemData.price * 100) /
					100;
			},
			async showUI() {
				const sys = await conDeop.sys().call();
				const usermine = await conMine.getPeopleTree(Account).call();

				this.systemData = sys;
				this.userId = await conDeop.UserId(Account).call();
				this.userData = await conDeop.User(this.userId).call();
				this.balanceOfATM = Number(await conATM.balanceOf(Account).call() )/ 100;
				this.balanceOfBTL = Math.floor(web3.utils.fromWei(await conBTL.balanceOf(Account).call()) *100)/100  ;
				//if (this.userData.father != 0) this.DepositRef = Number(this.userData.father).toString(16);
				this.depositTypes[0].rateKey = sys.rate_month_1/100;
				this.depositTypes[1].rateKey = sys.rate_month_3/100;
				this.depositTypes[2].rateKey = sys.rate_month_6/100;
				this.depositTypes[3].rateKey = sys.rate_month_12/100;
				//读出有几个存存款
				let deps = [];
				let time = await conHis.getTime().call();
				time = Math.floor(Number(time) /86400) 
				for(let i = 1 ;i<= this.userData.deopsitCount;i++){
					deps[i-1] = await conDeop.Deopsit(this.userId,i).call();
					deps[i-1].Index = i-1;
					deps[i-1].interest = await conDeop.calculate_interest(Account,deps[i-1].id).call();
					deps[i-1].interest = Math.floor(web3.utils.fromWei(deps[i-1].interest) * 10000)/10000;
					deps[i-1].isShow = time - deps[i-1].takeTime;
					
				}
				
				this.deposits = deps;
				
			},
			//取息
			async takeInterest(deposit){
				if(deposit.interest <= 0){
					MsgBox.open("提示","还没有产生利息");
					return;
				}
				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX("取息", "正在取利息，请等待链上确认");
					let par = {
						from: Account,
						to: addrDeop,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};
					par.gas = await conDeop.TakeProfit(deposit.id).estimateGas(par);				
					await conDeop.TakeProfit(deposit.id).send(par);
					MsgBox.open("兑换", "兑换成功")
					this.showUI();
				} catch (e) {
					if (e.message.indexOf("User denied") > 0) {
						MsgBox.open(Lang[lg]['t_12'], Lang[lg]['t_15']);
					} else
						MsgBox.open(Lang[lg]['t_13'], e);
				}
			},
			//取本
			async takePrincipal(deposit){
				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX("取息", "正在取利息，请等待链上确认");
					let par = {
						from: Account,
						to: addrDeop,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};
					par.gas = await conDeop.TakeDeopsit(deposit.id).estimateGas(par);				
					await conDeop.TakeDeopsit(deposit.id).send(par);
					MsgBox.open("兑换", "兑换成功")
					this.showUI();
				} catch (e) {
					if (e.message.indexOf("User denied") > 0) {
						MsgBox.open(Lang[lg]['t_12'], Lang[lg]['t_15']);
					} else
						MsgBox.open(Lang[lg]['t_13'], e);
				}
			},
			async AtmToBTL() {
				if (Number(this.InputAtmCount) < 50) {
					MsgBox.open("提示","兑换数量需不小于50");
					//this.InputAtmCount = Math.round(Number(this.balanceOfATM));
					return;
				}
				
				if (Number(this.InputAtmCount) > Number(this.balanceOfATM) ) {
					MsgBox.open("提示","ATM 余额不足");
					//this.InputAtmCount = Math.round(Number(this.balanceOfATM));
					return;
				}
				try {
					//先授权
					const atm = Number(this.InputAtmCount * 100);
					const allowance = await conATM.allowance(Account, addrDeop).call();
					if (atm > Number(allowance)) {
						MsgBox.waitTX("授权", "正在授权，请等待链上确认");
						let par = {
							from: Account,
							to: addrATM,
							gasPrice: await web3.eth.getGasPrice(),
							nonce: await web3.eth.getTransactionCount(Account)
						};
						par.gas = await conATM.approve(addrDeop, atm - Number(allowance)).estimateGas(par);
						await conATM.approve(addrDeop, atm - Number(allowance)).send(par);
						
					}
					
					
					MsgBox.waitTX("兑换", "正在兑换，请等待链上确认");
					let par = {
						from: Account,
						to: addrDeop,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};
					const gas = await conDeop.AtmToBTL(atm).estimateGas(par);

					par.gas = gas;
					await conDeop.AtmToBTL(atm).send(par);
					MsgBox.open("兑换", "兑换成功")
					this.showUI();
				} catch (e) {
					if (e.message.indexOf("User denied") > 0) {
						MsgBox.open(Lang[lg]['t_12'], Lang[lg]['t_15']);
					} else
						MsgBox.open(Lang[lg]['t_13'], e);
				}
			},

			async addDeposit() {
				let Type = this.newDepositType;
				if(Type != 1 && Type != 3 && Type != 6 && Type != 12){
					MsgBox.open("提示", "请选择存款期数");
					return;
				}
				if (this.newDepositAmount  > this.balanceOfBTL) {
					MsgBox.open("提示", "BTL 余额不足");
					return;
				}
				if(! Number("0x"+this.DepositRef)){
					MsgBox.open("提示", "请输入推荐码，存款推荐码与节点推荐码不同");
					return;
				}
				let ref = Number("0x"+this.DepositRef);
				let DeopAmount = web3.utils.toWei(this.newDepositAmount);
				
				try {
					//先授权
					const allowance = await conBTL.allowance(Account, addrDeop).call();
					if(Number(this.newDepositAmount) > web3.utils.fromWei(allowance) ){
						MsgBox.waitTX("授权", "正在授权，请等待链上确认");
						let par = {
							from: Account,
							to: addrBTL,
							gasPrice: await web3.eth.getGasPrice(),
							nonce: await web3.eth.getTransactionCount(Account)
						};
						par.gas = await conBTL.approve(addrDeop,DeopAmount).estimateGas(par);
						await conBTL.approve(addrDeop, DeopAmount).send(par);
						MsgBox.open("授权", "授权成功")
					}
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX("存款", "正在存款，请等待链上确认");
					let par = {
						from: Account,
						to: conDeop,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};
					//DeopsitBTL(uint24 ref,uint btl,uint8 Type)
					par.gas = await conDeop.DeopsitBTL(ref,DeopAmount,Type).estimateGas(par);
					await conDeop.DeopsitBTL(ref,DeopAmount,Type).send(par);
					MsgBox.open("存款", "存款成功")
					this.showUI();
				} catch (e) {
					if (e.message.indexOf("User denied") > 0) {
						MsgBox.open(Lang[lg]['t_12'], Lang[lg]['t_15']);
					} else
						MsgBox.open(Lang[lg]['t_13'], e);
				}
			},
			
			getRate(month) {
				/*depositTypes: [{
					months: 1,
					rateKey: 'rate_month_1'
				}, {
					months: 3,
					rateKey: 'rate_month_3'
				}, {
					months: 6,
					rateKey: 'rate_month_6'
				}, {
					months: 12,
					rateKey: 'rate_month_12'
				}],*/
				for(let i = 0 ;i<this.depositTypes.length;i++){
					if(month == this.depositTypes[i].months)return this.depositTypes[i].rateKey/month;
				}
				return 0;
			},
			formatTime (timestamp) {
				if (!timestamp) return '--'
				const date = new Date(timestamp * 86400 * 1000)
				
				return `${date.getFullYear()} 年 ${(date.getMonth()+1).toString().padStart(2,'0')}月${date.getDate().toString().padStart(2,'0')}`
			},
		},
	}

	/*import {
		ref,
		reactive,
		onMounted
	} from 'vue'

	export default {
		name: 'DarkBank',
		setup() {
			// 系统数据
			const systemData = reactive({
				userCount: 1248,
				price: 245, // 1 BTL = 24500 USDT
				rate_month_1: 2,
				rate_month_3: 9,
				rate_month_6: 24,
				rate_month_12: 60,
				totalDeposit: 2458
			})

			// 用户数据
			const userData = reactive({
				id: 10086,
				father: 10001,
				teamCount: 28,
				depositCount: 2,
				performance: 12500,
				teamProfit: 3420,
				deposit: 17000,
				addr: '0x71C7...970F'
			})

			// 存款列表
			const deposits = ref([])
			const newDepositAmount = ref(1000)
			const newDepositType = ref(3)

			const depositTypes = [{
					months: 1,
					rateKey: 'rate_month_1'
				},
				{
					months: 3,
					rateKey: 'rate_month_3'
				},
				{
					months: 6,
					rateKey: 'rate_month_6'
				},
				{
					months: 12,
					rateKey: 'rate_month_12'
				}
			]

			// 获取利率
			const getRate = (months) => {
				const map = {
					1: systemData.rate_month_1,
					3: systemData.rate_month_3,
					6: systemData.rate_month_6,
					12: systemData.rate_month_12
				}
				return map[months] || 0
			}

			// 计算利息 (简单单利)
			const calculateInterest = (deposit) => {
				if (deposit.status === 1) return 0
				const now = Math.floor(Date.now() / 1000)
				const start = deposit.createTime
				const months = deposit.type
				const totalSeconds = months * 30 * 24 * 3600
				const elapsed = Math.min(totalSeconds, Math.max(0, now - start))
				const ratio = elapsed / totalSeconds
				const rate = getRate(deposit.type) / 100
				const interest = deposit.deposit * rate * ratio
				return Math.floor(interest * 100) / 100
			}

			// 模拟生成时间 (相对当前)
			const randomTimeAgo = (daysAgo) => {
				return Math.floor(Date.now() / 1000) - daysAgo * 86400
			}

			// 初始化示例存款
			const initDeposits = () => {
				const now = Math.floor(Date.now() / 1000)
				deposits.value = [{
						id: 10001,
						createTime: randomTimeAgo(15),
						takeTime: randomTimeAgo(-15), // 15天后到期
						deposit: 5000,
						type: 1,
						status: 0
					},
					{
						id: 10002,
						createTime: randomTimeAgo(45),
						takeTime: randomTimeAgo(-45),
						deposit: 12000,
						type: 3,
						status: 0
					}
				]
				userData.depositCount = deposits.value.length
				userData.deposit = deposits.value.reduce((sum, d) => sum + d.deposit, 0)
				systemData.totalDeposit = 2458000 + userData.deposit
			}

			// 添加存款
			const addDeposit = () => {
				let amount = parseFloat(newDepositAmount.value)
				if (isNaN(amount) || amount <= 0) {
					alert('请输入有效金额')
					return
				}
				const now = Math.floor(Date.now() / 1000)
				const months = newDepositType.value
				const takeTime = now + months * 30 * 86400

				const newId = Date.now() % 100000
				deposits.value.push({
					id: newId,
					createTime: now,
					takeTime: takeTime,
					deposit: amount,
					type: months,
					status: 0
				})

				// 更新用户统计
				userData.depositCount = deposits.value.length
				userData.deposit += amount
				systemData.totalDeposit += amount
				newDepositAmount.value = 1000
			}

			// 取利息 (累加利息至团队奖励或余额概念，这里模拟弹窗)
			const takeInterest = (deposit) => {
				const interest = calculateInterest(deposit)
				if (interest <= 0) {
					alert('当前无利息可提取或未到期')
					return
				}
				// 模拟利息发放到余额 (更新团队奖励作为示意)
				userData.teamProfit += interest
				alert(`成功提取利息 $${interest.toFixed(2)} USDT，已加入团队奖励余额`)
			}

			// 取本金 (标记状态，扣除用户总存款)
			const takePrincipal = (deposit) => {
				if (deposit.status === 1) {
					alert('本金已提取过')
					return
				}
				const now = Math.floor(Date.now() / 1000)
				if (now < deposit.takeTime) {
					alert(`未到期无法提取本金，到期日 ${formatTime(deposit.takeTime)}`)
					return
				}
				deposit.status = 1
				userData.deposit -= deposit.deposit
				userData.depositCount = deposits.value.filter(d => d.status === 0).length
				alert(`本金 $${deposit.deposit} USDT 已提取至钱包`)
			}
			const 
			
			// 辅助函数
			const formatNumber = (num) => {
				if (num === undefined) return '0'
				return num.toLocaleString('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				})
			}

			const formatTime = (timestamp) => {
				if (!timestamp) return '--'
				const date = new Date(timestamp * 1000)
				return `${date.getMonth()+1}/${date.getDate()} ${date.getHours()}:${date.getMinutes().toString().padStart(2,'0')}`
			}

			const shortAddr = (addr) => {
				if (!addr) return ''
				return addr.length > 10 ? addr.slice(0, 6) + '...' + addr.slice(-4) : addr
			}

			onMounted(() => {
				initDeposits()
			})

			return {
				systemData,
				userData,
				deposits,
				newDepositAmount,
				newDepositType,
				depositTypes,
				getRate,
				calculateInterest,
				addDeposit,
				AtmToBTL,
				takeInterest,
				takePrincipal,
				formatNumber,
				formatTime,
				shortAddr,
				InputAtmCount
			}
		}
	}*/
</script>

<style scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.dark-bank {
		min-height: 100vh;
		background: #0a0a0f;
		position: relative;
		padding: 20px 16px 40px;
		font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
	}

	.bg-gradient {
		position: fixed;
		top: -20%;
		left: -20%;
		width: 140%;
		height: 140%;
		background: radial-gradient(circle at 30% 10%, rgba(0, 255, 255, 0.08), transparent 70%);
		pointer-events: none;
	}

	.container {
		max-width: 600px;
		margin: 0 auto;
		position: relative;
		z-index: 2;
	}

	/* 全网统计卡片 */
	.stats-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 12px;
		margin-bottom: 20px;
	}

	.stat-card {
		background: rgba(20, 20, 30, 0.7);
		backdrop-filter: blur(4px);
		border-radius: 6px;
		padding: 14px 8px;
		text-align: center;
		border: 1px solid rgba(255, 255, 255, 0.08);
		box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
	}

	.stat-label {
		font-size: 12px;
		color: #9ca3af;
		letter-spacing: 0.5px;
		margin-bottom: 6px;
	}

	.stat-value {
		font-size: 20px;
		font-weight: 700;
		background: linear-gradient(135deg, #fff, #a0f0ff);
		-webkit-background-clip: text;
		background-clip: text;
		color: transparent;
	}

	/* 利率条 */
	.rates-bar {
		display: flex;
		background: rgba(0, 0, 0, 0.6);
		border-radius: 12px;
		padding: 8px 12px;
		margin-bottom: 24px;
		justify-content: space-between;
		backdrop-filter: blur(8px);
		border: 1px solid rgba(255, 215, 0, 0.2);
	}

	.rate-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
	}

	.rate-item span {
		font-size: 11px;
		color: #aaa;
	}

	.rate-item strong {
		font-size: 18px;
		font-weight: 700;
		color: #f5c542;
	}

	/* 用户卡片 */
	.user-card {
		background: linear-gradient(145deg, #111118, #0c0c12);
		border-radius: 8px;
		padding: 20px;
		margin-bottom: 24px;
		border: 1px solid rgba(255, 255, 255, 0.05);
		box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
	}

	.user-header {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		font-size: 13px;
		color: #88aaff;
		padding-bottom: 16px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
		margin-bottom: 16px;
	}

	.user-id,
	.referrer,
	.address {
		background: rgba(100, 140, 255, 0.12);
		padding: 4px 12px;
		border-radius: 16px;
		font-weight: 500;
	}

	.user-stats {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 12px;
		margin-bottom: 20px;
	}

	.user-stat {
		background: rgba(0, 0, 0, 0.4);
		border-radius: 6px;
		padding: 10px 4px;
		text-align: center;
	}

	.user-stat span {
		display: block;
		font-size: 10px;
		color: #7e8493;
		margin-bottom: 6px;
	}

	.user-stat strong {
		font-size: 16px;
		color: white;
	}

	.user-balance {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		background: rgba(0, 200, 255, 0.08);
		padding: 14px 18px;
		border-radius: 8px;
		margin-top: 4px;
	}

	.user-balance span {
		font-size: 14px;
		color: #aab2c4;
	}

	.user-balance strong {
		font-size: 22px;
		font-weight: 800;
		color: #b9f6ff;
	}

	.cny {
		font-size: 12px;
		color: #6c86a3;
		margin-left: 6px;
	}

	/* 新增存款区 */
	.add-deposit {
		background: rgba(18, 20, 28, 0.9);
		border-radius: 12px;
		padding: 18px;
		margin-bottom: 28px;
		backdrop-filter: blur(4px);
	}

	.add-title {
		font-size: 16px;
		font-weight: 600;
		margin-bottom: 16px;
		color: #ddd;
	}

	.add-controls {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.amount-input {
		background: #1e1f2a;
		border: 1px solid #2f3342;
		border-radius: 8px;
		padding: 14px 20px;
		font-size: 16px;
		color: white;
		outline: none;
		transition: 0.2s;
	}

	.amount-input:focus {
		border-color: #3b82f6;
	}

	.type-selector {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}

	.type-btn {
		flex: 1;
		background: #1e1f2a;
		border: none;
		padding: 10px 0;
		border-radius: 6px;
		color: #bbb;
		font-weight: 500;
		transition: 0.2s;
		cursor: pointer;
	}

	.type-btn.active {
		background: #2c3e66;
		color: white;
		box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
	}

	.submit-btn {
		background: linear-gradient(95deg, #2a6f8f, #1e4a6e);
		border: none;
		padding: 14px;
		border-radius: 6px;
		font-weight: bold;
		font-size: 16px;
		color: white;
		cursor: pointer;
		transition: 0.2s;
	}

	.submit-btn:hover {
		transform: scale(0.98);
		background: linear-gradient(95deg, #1e5a7a, #12405c);
	}

	/* 存款列表 */
	.deposit-list {
		background: rgba(10, 12, 18, 0.7);
		border-radius: 12px;
		padding: 6px 4px;
	}

	.list-header {
		display: flex;
		justify-content: space-between;
		padding: 16px 18px 8px;
		font-size: 14px;
		color: #b9c7d9;
		font-weight: 500;
	}

	.hint {
		font-size: 11px;
		background: #1a1e2c;
		padding: 4px 10px;
		border-radius: 12px;
		color: #ffd966;
	}

	.deposit-item {
		background: #12141e;
		margin: 12px 12px;
		border-radius: 10px;
		padding: 18px;
		transition: 0.2s;
		border-left: 3px solid #3b82f6;
	}

	.deposit-item.inactive {
		display: none;
		opacity: 0.6;
		border-left-color: #6c757d;
		background: #0d0f16;
	}

	.deposit-amount {
		font-size: 22px;
		font-weight: 700;
		color: #fffaec;
		margin-bottom: 8px;
	}

	.deposit-meta {
		display: flex;
		gap: 12px;
		flex-wrap: wrap;
		margin-bottom: 12px;
	}

	.badge {
		background: #252a3a;
		padding: 4px 12px;
		border-radius: 20px;
		font-size: 11px;
		color: #b0c4ff;
	}

	.rate-badge {
		background: #3b2e1e;
		color: #ffbf69;
	}

	.date {
		font-size: 11px;
		color: #8f9bb3;
		align-self: center;
	}

	.profit-info {
		display: flex;
		gap: 12px;
		align-items: baseline;
		font-size: 13px;
		color: #6fcf97;
		margin-top: 6px;
	}

	.mature-date {
		color: #ffa25b;
		font-size: 11px;
	}

	.status-badge {
		margin-top: 12px;
		font-size: 13px;
		background: #2a2e3c;
		display: inline-block;
		padding: 4px 14px;
		border-radius: 8px;
	}

	.deposit-actions {
		display: flex;
		gap: 12px;
		margin-top: 18px;
	}

	.action-btn {
		flex: 1;
		padding: 10px 0;
		border-radius: 6px;
		font-weight: 600;
		border: none;
		cursor: pointer;
		font-size: 14px;
		transition: 0.15s;
	}

	.interest {
		background: #1f3a3f;
		color: #9effcf;
	}

	.interest:active {
		background: #0e2a2f;
	}

	.principal {
		background: #3c2a2a;
		color: #ffaa88;
	}

	.principal:active {
		background: #2e1f1f;
	}

	.empty-state {
		text-align: center;
		padding: 48px 20px;
		color: #6c7a8e;
		font-size: 15px;
	}

	/* 长按提示简单模拟，未做原生长按，但按钮文案示意 */
	.action-btn.principal {
		position: relative;
	}
</style>